let util = {
    getEnv() {
        return window.location.host.split('.')[0] === 'staging' ? 'stage' : (window.location.host.split('.')[0].indexOf('localhost') >= 0 ? 'dev' : 'prod')
    },
    getAPIUrl() {
        return this.getEnv() !== 'dev' ? `https://605jjneru5.execute-api.us-west-2.amazonaws.com/${this.getEnv()}` : 'https://605jjneru5.execute-api.us-west-2.amazonaws.com/stage';
    }
}

export default util;